import { useEffect, useState } from "react";

export default function CursorDot() {
  const [pos, setPos] = useState({ x: -100, y: -100 });
  const [active, setActive] = useState(false);
  useEffect(() => {
    const move = (e) => setPos({ x: e.clientX, y: e.clientY });
    const over = (e) => {
      const t = e.target;
      if (t.closest("button, a, [data-cursor='active']")) setActive(true);
      else setActive(false);
    };
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", over);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
    };
  }, []);
  return <div className={`cursor-dot ${active ? "active" : ""}`} style={{ transform: `translate(${pos.x}px, ${pos.y}px) translate(-50%,-50%)` }} data-testid="cursor-dot" />;
}
